export const MEDIAOBJECT_DELETE_RESET = 'MEDIAOBJECT_DELETE_RESET';
export const MEDIAOBJECT_DELETE_SET_ERROR = 'MEDIAOBJECT_DELETE_SET_ERROR';
export const MEDIAOBJECT_DELETE_SET_DELETED = 'MEDIAOBJECT_DELETE_SET_DELETED';
export const MEDIAOBJECT_DELETE_TOGGLE_LOADING = 'MEDIAOBJECT_DELETE_TOGGLE_LOADING';



// WEBPACK FOOTER //
// ./src/store/modules/mediaobject/delete/mutation_types.js